import { useCallback, useState } from 'react';

let idCounter = 0;

// Maneja una pila de toasts locales con expiración manual
export function useToasts() {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(({ type = 'info', message }) => {
    idCounter += 1;
    const toast = { id: idCounter, type, message };
    setToasts(prev => [...prev, toast]);
    return toast.id;
  }, []);

  const removeToast = useCallback(id => {
    setToasts(prev => prev.filter(item => item.id !== id));
  }, []);

  const clearToasts = useCallback(() => {
    setToasts([]);
  }, []);

  return { toasts, addToast, removeToast, clearToasts };
}

export default useToasts;
